class ScriptService
{
    async loadData(path) {
        return new Promise((resolve, reject) => {
            var script = document.createElement("script");
            script.onload = () => resolve();
            script.onerror = (e) => reject(e);
            script.src = process.env.PUBLIC_URL + path;
            document.body.appendChild(script);
        });
    };
}

export default new ScriptService();